/************************************
MODULE:         OFFERS POPUP
WHAT IT DOES:   shows some limited-time offers
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function initOffer() {
        if (typeof window.safestoreOffersSettings == 'undefined')
            return;

        var history = require('app.history');
        var isOffersShown = history.getFromSessionStorage('safestore_offer_shown');
        if (isOffersShown === "true")
            return;
        history.setToSessionStorage('safestore_offer_shown', true);
        setTimeout(openOffer, 3000);
    }

    function openOffer() {
        $('html').addClass('large-simplepopup');
        $(window).on('closed:simplepopup', onCloseOffer);
        $(window).trigger('open:simplepopup', { data: window.safestoreOffersSettings, template: 'offers' });
    }

    function onCloseOffer() {
        $('html').removeClass('large-simplepopup');
    }


    return {
        init: initOffer
    }

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.offer.js
 ** module id = 47
 ** module chunks = 24
 **/